import type { ReactElement } from "react";

import OnboardingHubCompleted from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubCompleted/OnboardingHubCompleted";
import type {
    OnboardingHubContentWrapperProps,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubContentWrapper/OnboardingHubContentWrapper";
import OnboardingHubContentWrapper from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubContentWrapper/OnboardingHubContentWrapper";
import type {
    OnboardingHubTasksProps,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubTasks/OnboardingHubTasks";
import OnboardingHubTasks from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubTasks/OnboardingHubTasks";
import OnboardingHubTasksInSidebar from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubTasks/OnboardingHubTasksInSidebar";

interface OnboardingHubContentContainerProps extends OnboardingHubContentWrapperProps, OnboardingHubTasksProps {
    inSidebar: boolean;
    isHubActive?: boolean;
}

const OnboardingHubContentContainer = ({
    tasks,
    onTaskActionClick,
    completedItemsCount,
    totalItemsCount,
    onCloseHub,
    inSidebar,
    expandedType,
    handleTaskState,
    isHubActive,
}: OnboardingHubContentContainerProps): ReactElement => {
    const renderOnboardingContent = () => {
        if (totalItemsCount > 0 && completedItemsCount >= totalItemsCount) {
            return <OnboardingHubCompleted isInSidebar={inSidebar} />;
        }
        if (inSidebar) {
            return (
                <OnboardingHubTasksInSidebar
                    tasks={tasks}
                    onTaskActionClick={onTaskActionClick}
                    handleTaskState={handleTaskState}
                    expandedType={expandedType}
                    isHubActive={isHubActive as boolean}
                />
            );
        }
        return (
            <OnboardingHubTasks
                tasks={tasks}
                onTaskActionClick={onTaskActionClick}
                expandedType={expandedType}
                handleTaskState={handleTaskState}
            />
        );
    };
    return (
        <OnboardingHubContentWrapper
            inSidebar={inSidebar}
            onCloseHub={onCloseHub}
            totalItemsCount={totalItemsCount}
            completedItemsCount={completedItemsCount}
        >
            {renderOnboardingContent()}
        </OnboardingHubContentWrapper>
    );
};

export default OnboardingHubContentContainer;
